import Vue from 'vue';

import Config from './../config/index';


import routes from './index';

import Router from 'vue-router';

import Sto from 'store';

import {
	Loading,
	Message
} from 'element-ui'

import iView from 'view-design'

Vue.use(iView)
Vue.use(Router)

// 加载进度条颜色和宽度设置
iView.LoadingBar.config({
	color: '#B34536',
	failedColor: '#f0ad4e',
	height: 2
});

// let loadinginstace

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
};

// 创建路由实例
const router = new Router({
	routes: routes,
	// mode: 'history',
	strict: process.env.NODE_ENV === 'development' // 生产环境使用严格模式
})

// 如果没有过期就更新cookies数据，保持登录状态
function updateToken() {

	let cookies = Sto.get(Config.constant.cookie)
	cookies = cookies ? cookies : {}
	// // 登录用户TOKEN
	// let token = cookies.hasOwnProperty('token') ? cookies.token : ''
	// // 登录用户的ID
	// let userid = cookies.hasOwnProperty('userid') ? cookies.userid : ''
	// // 登录后，登录用户对象
	// let user = cookies.hasOwnProperty('user') ? cookies.user : {}
	// // tokentime保存的时间
	// let tokenTime = cookies.hasOwnProperty('tokenTime') && (new Date()).getTime() - cookies.tokenTime < 7200000 ?  (new Date()).getTime() : ''
	// cookies = {
	// 	tokenTime : tokenTime,
	// 	token : token,
	// 	userid : userid,
	// 	user : user,
	// }
	cookies['tokenTime'] = cookies.hasOwnProperty('tokenTime') && (new Date()).getTime() - cookies.tokenTime < 7200000 ?
		(new Date()).getTime() : ''
	Sto.set(Config.constant.cookie, cookies)
}

// 拦截用户放问路由的权限,并且初始化导航栏需要的数据
async function filterPermissionRouter(to, next) {
	let cookies = Sto.get(Config.constant.cookie)
	let access = [] // = cookies.hasOwnProperty('user') ? cookies.user.permission_index : []
	let permissions = []
	// 查找角色权限
	await AdminUserApi.findAdminPermission().then(request => {
		let res = request.data

		access = res.body.permission_index
		let nav = {
			paths: access,
			treeList: res.body.threePermissions
		}
		Sto.set(Config.nav, nav)

		permissions = res.body.permissions
	})

	// 必须
	/* 	if(cookies.hasOwnProperty('user')){
			// 三级菜单显示
			cookies.user.permission_index = access
			// 控制按钮操作权限
			cookies.user.permissions = permissions
			Sto.set(Config.constant.cookie, cookies)
		} */
	access.push('/')
	access.push('/403')
	access.push('/404')
	access.push('/500')
	if (access.length > 0) {
		let hasPermission = access.filter(x => {
			return x == to.path
		})
		//权限判断
		if (hasPermission.length == 0) {
			Message.error({
				message: '无权访问当前链接' //权限开关
			})
			next(Config.route.error403)
			return false
		}
	}
	return true
}

router.beforeEach((to, from, next) => {
	iView.LoadingBar.start()
	// loadinginstace = Loading.service({ fullscreen: true })
	let cookies = Sto.get(Config.constant.cookie);
	// if ((!cookies || !cookies.tokenTime) && to.path != Config.route.login) {
	// 	// 退出登录后
	// 	next(Config.route.login)
	// } else if (cookies && cookies.tokenTime && to.path != Config.route.login) {

	// 	// 保存2个小时TOKEN,需要改进不然使用中也会导致过期
	// 	if ((new Date()).getTime() - cookies.tokenTime > 7200000) {
	// 		delete cookies.tokenTime;
	// 		Sto.set(Config.constant.cookie, {})

	// 		Message.error({
	// 			message: '登录超时'
	// 		})
	// 		next(Config.route.login)
	// 	} else {
	// 		// token更新
	// 		updateToken()
	// 		// 权限过滤
	// 		filterPermissionRouter(to, next)
	// 		.then(request => {
	// 			if(request){
	// 				next()
	// 			}
	// 		})
	// 		.catch((error)=>{
	// 			next(Config.route.error500)
	// 		})
	// 		next()
	// 	}
	// } else {
	// 	next()
	// }
	next()
})

router.afterEach((transition) => {
	iView.LoadingBar.finish()
	// loadinginstace.close()
})

export default router



// WEBPACK FOOTER //
// ./src/router/router.js